import { CloseIcon, CloseCircleFilledIcon, DeleteIcon, CartIcon, EllipsisIcon, FolderIcon, FolderOpenIcon, SoundIcon, CallIcon, UserIcon, BrowseIcon, BrowseOffIcon, CheckCircleIcon, ErrorCircleIcon, LoadingIcon, ArrowUpIcon, ArrowDownIcon, ArrowLeftStrokeIcon, AddIcon, RemoveIcon, SettingIcon, EditIcon, FileCopyIcon, MobileIcon, LogoWechatIcon, MailIcon, LogoQqIcon, ViewListIcon, ChartBarIcon, DownloadIcon, FilterIcon, InfoCircleIcon, CaretUpIcon, CaretDownIcon, CaretLeftIcon, CaretRightIcon, JumpIcon, RefreshIcon, Fullscreen2Icon, FullscreenExit2Icon, MoveIcon, NotificationFilledIcon, HelpCircleIcon, TimeIcon, NextIcon, PreviousIcon, SearchIcon, SwapIcon, 
// RoundIcon,
MenuUnfoldIcon, CheckIcon, MinusCircleIcon, AddCircleIcon, QrcodeIcon, ServerIcon, LogoWindowsIcon, ChartPieIcon, BulletpointIcon, ForkIcon, DiscountIcon, GuideRectangleIcon, UserConfirmedIcon, SortIcon, PhoneConfirmedIcon, PhoneWarningIcon, PhoneErrorIcon, WechatConfirmedIcon, WechatWarningIcon, WechatErrorIcon, EmailConfirmedIcon, EmailWarningIcon, EmailErrorIcon, ViewGridIcon, ConvertipIcon, ChartLineIcon, MultiLineIcon, PercentIcon, TeachingIcon, 
// SettingFilledIcon,
CurActiveIcon, FileDailyIcon, CurIcon, MonitorIcon, } from "@tencent/tea-icons-react";
import React from "react";
export var teaIconsMap = {
    // close
    close: React.createElement(CloseIcon, null),
    // close-circle-filled
    dismiss: React.createElement(CloseCircleFilledIcon, null),
    // delete
    delete: React.createElement(DeleteIcon, null),
    // cart
    shopcart: React.createElement(CartIcon, null),
    // ellipsis
    more: React.createElement(EllipsisIcon, null),
    // folder
    folderclose: React.createElement(FolderIcon, null),
    // folder-open
    folderopen: React.createElement(FolderOpenIcon, null),
    // sound
    notice: React.createElement(SoundIcon, null),
    // empty
    guide: React.createElement(GuideRectangleIcon, null),
    // call
    consult: React.createElement(CallIcon, null),
    // user
    realname: React.createElement(UserIcon, null),
    // empty
    realnamev: (React.createElement(UserConfirmedIcon, { colors: [
            {
                targetColor: "black",
                reviseColor: "var(--tea-color-text-primary,rgba(0,0,0,.9))",
            },
            {
                targetColor: "#00A870",
                reviseColor: "var(--tea-color-text-success-default,#0cbf5b)",
            },
        ] })),
    // browse
    show: React.createElement(BrowseIcon, null),
    // browse-off
    hide: React.createElement(BrowseOffIcon, null),
    // check-circle
    success: (React.createElement(CheckCircleIcon, { color: "var(--tea-color-text-success-default,#0cbf5b)" })),
    // error-circle
    warning: (React.createElement(ErrorCircleIcon, { color: "var(--tea-color-text-warning-default,#ff7800)" })),
    // loading
    loading: React.createElement(LoadingIcon, { color: "var(--tea-color-text-brand-default,#0052d9)" }),
    // error-circle
    error: (React.createElement(ErrorCircleIcon, { color: "var(--tea-color-text-error-default,#f64041)" })),
    // empty
    sort: React.createElement(SortIcon, null),
    // arrow-up
    sortup: React.createElement(ArrowUpIcon, null),
    // arrow-down
    sortdown: React.createElement(ArrowDownIcon, null),
    // arrow-left-stroke
    btnback: React.createElement(ArrowLeftStrokeIcon, null),
    // add
    plus: React.createElement(AddIcon, null),
    // remove
    minus: React.createElement(RemoveIcon, null),
    // setting
    setting: React.createElement(SettingIcon, null),
    // edit
    pencil: React.createElement(EditIcon, null),
    // file-copy
    copy: React.createElement(FileCopyIcon, null),
    // empty
    remind: null,
    // mobile
    phone: React.createElement(MobileIcon, null),
    // empty
    phonev: (React.createElement(PhoneConfirmedIcon, { colors: [
            {
                targetColor: "black",
                reviseColor: "var(--tea-color-text-primary,rgba(0,0,0,.9))",
            },
            {
                targetColor: "#00A870",
                reviseColor: "var(--tea-color-text-success-default,#0cbf5b)",
            },
        ] })),
    // empty
    "phone-warning": (React.createElement(PhoneWarningIcon, { colors: [
            {
                targetColor: "black",
                reviseColor: "var(--tea-color-text-primary,rgba(0,0,0,.9))",
            },
            {
                targetColor: "#F86F00",
                reviseColor: "var(--tea-color-text-warning-default,#ff7800)",
            },
        ] })),
    // empty
    "phone-error": (React.createElement(PhoneErrorIcon, { colors: [
            {
                targetColor: "black",
                reviseColor: "var(--tea-color-text-primary,rgba(0,0,0,.9))",
            },
            {
                targetColor: "#D54941",
                reviseColor: "var(--tea-color-text-error-default,#f64041)",
            },
        ] })),
    // logo-wechat
    wechat: React.createElement(LogoWechatIcon, null),
    // empty
    wechatv: (React.createElement(WechatConfirmedIcon, { colors: [
            {
                targetColor: "black",
                reviseColor: "var(--tea-color-text-primary,rgba(0,0,0,.9))",
            },
            {
                targetColor: "#00A870",
                reviseColor: "var(--tea-color-text-success-default,#0cbf5b)",
            },
        ] })),
    // empty
    "wechat-warning": (React.createElement(WechatWarningIcon, { colors: [
            {
                targetColor: "black",
                reviseColor: "var(--tea-color-text-primary,rgba(0,0,0,.9))",
            },
            {
                targetColor: "#F86F00",
                reviseColor: "var(--tea-color-text-warning-default,#ff7800)",
            },
        ] })),
    // empty
    "wechat-error": (React.createElement(WechatErrorIcon, { colors: [
            {
                targetColor: "black",
                reviseColor: "var(--tea-color-text-primary,rgba(0,0,0,.9))",
            },
            {
                targetColor: "#D54941",
                reviseColor: "var(--tea-color-text-error-default,#f64041)",
            },
        ] })),
    // mail
    email: React.createElement(MailIcon, null),
    // empty
    emailv: (React.createElement(EmailConfirmedIcon, { colors: [
            {
                targetColor: "black",
                reviseColor: "var(--tea-color-text-primary,rgba(0,0,0,.9))",
            },
            {
                targetColor: "#00A870",
                reviseColor: "var(--tea-color-text-success-default,#0cbf5b)",
            },
        ] })),
    // empty
    "email-warning": (React.createElement(EmailWarningIcon, { colors: [
            {
                targetColor: "black",
                reviseColor: "var(--tea-color-text-primary,rgba(0,0,0,.9))",
            },
            {
                targetColor: "#F86F00",
                reviseColor: "var(--tea-color-text-warning-default,#ff7800)",
            },
        ] })),
    // empty
    "email-error": (React.createElement(EmailErrorIcon, { colors: [
            {
                targetColor: "black",
                reviseColor: "var(--tea-color-text-primary,rgba(0,0,0,.9))",
            },
            {
                targetColor: "#D54941",
                reviseColor: "var(--tea-color-text-error-default,#f64041)",
            },
        ] })),
    // logo-qq
    qq: React.createElement(LogoQqIcon, null),
    // empty
    viewgrid: React.createElement(ViewGridIcon, null),
    // view-list
    viewlist: React.createElement(ViewListIcon, null),
    // chart-bar
    monitor: React.createElement(MonitorIcon, null),
    // download
    download: React.createElement(DownloadIcon, null),
    // empty
    filter: React.createElement(FilterIcon, null),
    // empty
    "convertip--blue": (React.createElement(ConvertipIcon, { color: "var(--tea-color-text-brand-default,#0052d9)" })),
    // empty
    convertip: React.createElement(ConvertipIcon, null),
    // info-circle
    info: React.createElement(InfoCircleIcon, null),
    // caret-up
    arrowup: React.createElement(CaretUpIcon, null),
    // empty
    arrowdown: React.createElement(CaretDownIcon, null),
    // empty
    arrowleft: React.createElement(CaretLeftIcon, null),
    // empty
    arrowright: React.createElement(CaretRightIcon, null),
    // jump
    externallink: (React.createElement(JumpIcon, { color: "var(--tea-color-text-brand-default,#0052d9)" })),
    // refresh
    refresh: React.createElement(RefreshIcon, null),
    // refresh
    "refresh-blue": (React.createElement(RefreshIcon, { color: "var(--tea-color-text-brand-default,#0052d9)" })),
    // fullscreen
    fullscreen: React.createElement(Fullscreen2Icon, null),
    // fullscreen-exit
    fullscreenquit: React.createElement(FullscreenExit2Icon, null),
    // arrow-down
    trenddown: (React.createElement(ArrowDownIcon, { color: "var(--tea-color-text-success-default,#0cbf5b)" })),
    // arrow-up
    trendup: React.createElement(ArrowUpIcon, { color: "var(--tea-color-text-error-default,#f64041)" }),
    // move
    drop: React.createElement(MoveIcon, null),
    // notification-filled
    news: React.createElement(NotificationFilledIcon, null),
    // help-circle
    help: React.createElement(HelpCircleIcon, null),
    // time
    "pending-gray": React.createElement(TimeIcon, null),
    // time
    pending: React.createElement(TimeIcon, { color: "var(--tea-color-text-warning-default,#ff7800)" }),
    // info-circle
    infoblue: (React.createElement(InfoCircleIcon, { color: "var(--tea-color-text-brand-default,#0052d9)" })),
    // next
    lastpage: React.createElement(NextIcon, null),
    // previous
    firstpage: React.createElement(PreviousIcon, null),
    // search
    search: React.createElement(SearchIcon, null),
    // swap
    transfer: React.createElement(SwapIcon, null),
    // round
    cur: React.createElement(CurIcon, null),
    // empty
    "cur-active": React.createElement(CurActiveIcon, null),
    // menu-unfold
    fold: React.createElement(MenuUnfoldIcon, null),
    // check
    check: React.createElement(CheckIcon, null),
    // minus-circle
    not: React.createElement(MinusCircleIcon, null),
    // add-circle
    and: React.createElement(AddCircleIcon, { color: "var(--tea-color-text-success-default,#0cbf5b)" }),
    // qrcode
    qrcode: React.createElement(QrcodeIcon, null),
    // server
    database: React.createElement(ServerIcon, null),
    // logo-windows
    datasheet: React.createElement(LogoWindowsIcon, null),
    // empty
    daily: React.createElement(FileDailyIcon, null),
    // chart-pie
    "chart-pie": React.createElement(ChartPieIcon, null),
    // chart-pie
    "chart-pie-hover": (React.createElement(ChartPieIcon, { color: "var(--tea-color-text-brand-default,#0052d9)" })),
    // empty
    "chart-line": React.createElement(ChartLineIcon, null),
    // empty
    "chart-line-hover": (React.createElement(ChartLineIcon, { color: "var(--tea-color-text-brand-default,#0052d9)" })),
    // chart-bar
    "chart-column": React.createElement(ChartBarIcon, null),
    // chart-bar
    "chart-column-hover": (React.createElement(ChartBarIcon, { color: "var(--tea-color-text-brand-default,#0052d9)" })),
    // bulletpoint
    table: React.createElement(BulletpointIcon, null),
    // bulletpoint
    "table-hover": (React.createElement(BulletpointIcon, { color: "var(--tea-color-text-brand-default,#0052d9)" })),
    // fork
    relationship: React.createElement(ForkIcon, null),
    // fork
    "relationship-hover": (React.createElement(ForkIcon, { color: "var(--tea-color-text-brand-default,#0052d9)" })),
    // empty
    "multi-line": React.createElement(MultiLineIcon, null),
    // empty
    percent: React.createElement(PercentIcon, null),
    // empty
    "percent-blue": (React.createElement(PercentIcon, { color: "var(--tea-color-text-brand-default,#0052d9)" })),
    // discount
    tag: React.createElement(DiscountIcon, null),
    // empty
    teaching: (React.createElement(TeachingIcon, { color: "var(--tea-color-text-brand-default,#0052d9)" })),
    detail: React.createElement(EllipsisIcon, null),
};
//# sourceMappingURL=tea-icons-map.js.map